import { useLoaderData } from "react-router";
import EditableHeading from "./components/EditableHeading/EditableHeading";
import EditableIntroduction from "./components/EditableIntroduction/EditableIntroduction";
import Speakers from "../../clients/PastGeb/components/speakers/speakers";
import EditableShortIntro from "./components/EditableShortIntro/EditableShortIntro";
import BusinessIdeas from "../../clients/PastGeb/components/BusinessIdeas/BusinessIdeas";
import Slider from "../../clients/PastGeb/components/Experience/Slider";

const AdminPastGeb = () => {
  let pastGeb = useLoaderData();
  let { _id, editionNumber, eventDate, eventLocation } = pastGeb;
  // console.log("pg = ", pastGeb)

  var nth = `${editionNumber}th`;
  if (editionNumber === 1)
    nth = `${editionNumber}st`;
  if (editionNumber === 2)
    nth = `${editionNumber}nd`;
  if (editionNumber === 3)
    nth = `${editionNumber}rd`;

  return (
    <div>
      <div className="past_geb_container organizer_container">
        <EditableHeading nth={nth} id={_id}
          eventDate={eventDate} editionNumber={editionNumber}
          eventLocation={eventLocation} />
        <div className="op_top_horizontal_line" />
        <EditableIntroduction id={_id} />
        <div className="op_top_horizontal_line" />
        <Speakers id={_id} isAdmin={true} nth={nth} />
        <div className="op_top_horizontal_line" />
        <EditableShortIntro id={_id} nth={nth} />
        <BusinessIdeas id={_id} isAdmin={true} />
      </div>
      <Slider id={_id} isAdmin={true} />
    </div>
  );
};

export default AdminPastGeb;
